export default function Game_Movement() {
  return (
    <div>
      <h1>Game_Movement Component</h1>
    </div>
  );
}
